import React, { useContext, useState } from 'react'
import { Grid, GridCell, ListMenu, ListMenuButton, Modal, Spacer, View } from 'oio-react'
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { PeopleIcon } from 'assets/icons'
import uiConstants from 'config/constants/ui'
import PrivacySelector from 'src/apps/Initiative/apps/PrivacySelector'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { initiativeSettingsUrl } from 'src/components/utils/urls'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import PeopleRole from './Role'

const InitiativePeopleSettings = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const [modalIsOpen, setModalIsOpen] = useState(true)

   return (
      <View>
         <ProtoReturnBar
            display="block[a-c] none[d-f]"
            returnLinkName={`${initiative.type.nameSingular} Settings`}
            returnLinkTo={initiativeSettingsUrl()}
         />
         <View display="flex" justifyContent="center" width="100%">
            <View
               maxWidth="100%[a-c] 690px[d-f]"
               padding="20px[a] 25px[b] 30px[c] 40px[d-f]">
               <View width="660px">
                  <View
                     width="100%"
                     marginBottom="24px"
                     display="flex">
                     <View maxWidth="540px" paddingRight="60px">
                        <ProtoHeadingBlock
                           title={`${initiative.type.nameSingular} People, Roles & Permissions`}
                           description={`Manage who can see and ${initiative.joinVerb} this ${initiative.type.nameSingular}. Invite new people to become Admins or Members of this ${initiative.type.nameSingular}.`}
                           icon={(
                              <PeopleIcon
                                 width="14px"
                                 height="14px"
                                 color="#fff"
                                 strokeWidth="2px"
                              />
                           )}
                        />
                     </View>
                  </View>
                  <Spacer size="3" />
                  <Grid>
                     <GridCell colspan="3">
                        <ListMenu
                           activeBackgroundColor="#333"
                           activeTextColor="#fff"
                           buttonBorderRadius="4px"
                           buttonSize="md"
                           buttonPaddingHorizontal="12px"
                           showActiveArrow>
                           {initiative.roles.map(role => (
                              <ListMenuButton
                                 key={role.id}
                                 linkTo={`${match.url}/role/${role.id}`}
                                 name={`${role.name} (${role.numActiveUsers})`}
                              />
                           ))}
                        </ListMenu>
                     </GridCell>
                     <GridCell colspan="9">
                        <Switch>
                           <Redirect
                              exact
                              from={match.url}
                              to={`${match.url}/role/${initiative.roles[0].id}`}
                           />
                           <Route
                              component={PeopleRole}
                              path={[
                                 `${match.url}/role/:roleId/:roleStatus(declined|invited|inactive)`,
                                 `${match.url}/role/:roleId`
                              ]}
                           />
                        </Switch>
                     </GridCell>
                  </Grid>
               </View>
            </View>
         </View>
         <Switch>
            <Route
               path={`${match.url}/select-privacy`}
               render={() => (
                  <Modal
                     borderRadius="6px"
                     width="100%"
                     maxWidth="480px"
                     onCloseComplete={() => {
                        history.push(match.url)
                        setModalIsOpen(true)
                     }}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     open={modalIsOpen}
                     zIndex={uiConstants.zIndexes.tmpSettingsModal}>
                     <PrivacySelector onCloseButtonClick={() => setModalIsOpen(false)} />
                  </Modal>
               )}
            />
         </Switch>
      </View>
   )
}

export default InitiativePeopleSettings
